module.exports = __webpack_public_path__ + "static/media/S (127).045f4454.jpg";